import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconBus = function IconBus(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-bus"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "M20 21.4a.6.6 0 0 1-.6.6h-2.8a.6.6 0 0 1-.6-.6V21H8v.4a.6.6 0 0 1-.6.6H4.6a.6.6 0 0 1-.6-.6V12h-.4a.6.6 0 0 1-.6-.6V8.6c0-.33.27-.6.6-.6H4V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3h.4c.33 0 .6.27.6.6v2.8a.6.6 0 0 1-.6.6H20zm-2-6.7a61 61 0 0 1-12 0V18c0 .54.46 1 1 1h10c.54 0 1-.46 1-1zM18 5c0-.54-.46-1-1-1H7c-.54 0-1 .46-1 1v7.69a58 58 0 0 0 12 0zm-8 12a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m5 1h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2"
  }, pathRest)));
};
IconBus.displayName = 'InlineIcon(IconBus)';
IconBus.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconBus };
